import { generateAccountStatusId } from 'dashboard/lib/stubs/account';
import { generateAccountTypeId } from 'dashboard/lib/stubs/account-type';
import { AccountStatus, AccountStatusAttributes } from 'dashboard/models/account-status';
import { ApiModel } from 'lib/interfaces/api';

export function createPreviewAccountStatus(
  attributes?: Partial<AccountStatusAttributes>,
  id?: string,
  accountTypeId?: string,
): AccountStatus {
  return {
    id: id || generateAccountStatusId(),
    type: ApiModel.AccountStatus,
    attributes: {
      'archived-at': attributes?.['archived-at'] || '2019-09-20T09:30:12.000Z',
      'created-at': '2019-09-20T05:30:12.000Z',
      'updated-at': '2019-09-20T08:30:12.000Z',
      name: attributes?.['name'] || 'created',
      'display-name': attributes?.['name'] || 'created (account status)',
    },
    relationships: {
      'account-type': {
        data: {
          type: ApiModel.AccountType,
          id: accountTypeId || generateAccountTypeId(),
        },
      },
    },
  };
}
